import { PaymentsApi } from '../clients';

export const downloadACHAuthorizationRecord = async (bankId) => {
  const blob = await PaymentsApi.downloadACHAuthorizationRecord(bankId);

  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `authorization-record-${bankId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
